import type { DownloadProductDumpAllApi } from 'hooks/useProductDumpAll';
import type { DownloadProductDumpMainApi } from 'hooks/useProductDumpMain';
import type { DownloadProductDumpMarketDataApi } from 'hooks/useProductDumpMarketData';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';
export type IProductDumpApi = DownloadProductDumpAllApi & DownloadProductDumpMainApi & DownloadProductDumpMarketDataApi;

export const productDumpConnector = (http$: IHttpClient): IProductDumpApi => ({
  downloadProductDumpAll(pricingId: string) {
    return http$
      .getBlob({
        url: `api/v1/product-dump/all?pricingId=${pricingId}`,
        targetHost: 'AdvisoryBridge',
      })
      .pipe(map(({ payload }) => payload));
  },
  downloadProductDumpMain(pricingId: string) {
    return http$
      .getBlob({
        url: `api/v1/product-dump/main?pricingId=${pricingId}`,
        targetHost: 'AdvisoryBridge',
      })
      .pipe(map(({ payload }) => payload));
  },
  downloadProductDumpMarketData(pricingId: string) {
    return http$
      .getBlob({
        url: `api/v1/product-dump/market-data?pricingId=${pricingId}`,
        targetHost: 'AdvisoryBridge',
      })
      .pipe(map(({ payload }) => payload));
  },
});
